<template>
  <div>
    <div class="container content">
      <span class="back" @click="goBack">
        <font-awesome-icon icon="angle-left"/>
        <span>Вернуться на главную</span>
      </span>
      <h1 class="center">Выберите группу</h1>
      <app-search @change="handleFilter"></app-search>
      <div class="relative">
        <loader ref="loader"/>
        <div class="grid">
          <div class="row">
            <div class="col-3 col-1-xs" v-for="group in groups" :key="group.id">
              <div class="btn" @click="setGroupId(group.id)">{{group.name}} ({{group.theme.name}})</div>
            </div>
          </div>
        </div>
      </div>
      <pagination @change="setPage" :itemsPerPage="itemsPerPage" :resultCount="resultCount"/>
    </div>
  </div>
</template>

<script>
  import GroupsService from '@/services/GroupsService'

  export default {
    name: 'start-group',
    data () {
      return {
        groups: [],
        filter: '',
        currentPage: 1,
        itemsPerPage: 10,
        resultCount: 0
      }
    },
    computed: {},
    methods: {
      goBack () {
        this.$emit('setPage', 1)
      },
      setGroupId (groupId) {
        this.$store.dispatch('setGroupId', groupId)
        this.$emit('setPage', 4)
      },
      handleFilter: function (filter) {
        this.filter = filter
        this.getGroups()
      },
      setPage (pageNumber) {
        this.currentPage = pageNumber
        this.getGroups()
      },
      getGroups () {
        this.$refs.loader.show()
        const slug = this.$route.params.slug
        GroupsService.getGroups(slug, this.currentPage, this.itemsPerPage, this.filter).then(
          (response) => {
            this.groups = response.results
            this.resultCount = response.count
            this.$refs.loader.hide()
          }
        )
      }
    },
    mounted () {
      this.getGroups()
    }
  }
</script>

<style scoped lang="scss">
  .content {
    min-height: calc(100vh - 212px);
  }

  .col-3 {
    margin: 7px 0;
    .btn {
      padding: 25px 20px;
      @media screen and (max-width: 500px) {
        font-size: 14px;
        height: auto;
        padding: 10px;
        font-weight: 400;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/game/StartGroup.vue